import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CanDeactivateEditMapGuard } from './core/auth/edit-map.guard';
import { TokenInterceptor } from './core/auth/token.interceptor';
import { CoreModule } from './core/core.module';
import { MapService } from './core/helper/map.service';
import { ErrorNotifierInterceptor } from './core/interceptor/error-handler.interceptor';
import { CreateAccountModule } from './feature/create-account/create-account.module';
import { DiagnosticsModule } from './feature/diagnostics/diagnostics.module';
import { HomeModule } from './feature/home/home.module';
import { SharedModule } from './shared';
import { metaReducers, reducers } from './store';
import { AdminEffects } from './store/admin/admin.effects';
import { AppConfigEffects } from './store/app-config/app-config.effects';
import { AuthEffects } from './store/auth/auth.effects';
import { MapControlEffects } from './store/map-control/map-control.effects';
import { NotificationEffects } from './store/notification/notification.effects';
import { ParcelEffects } from './store/parcel/parcel.effects';
import { SiteEffects } from './store/site/site.effects';

import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppConfigService } from './core/api/app-config.service';
import { SiteStatusService } from './core/helper/site-status.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),

    /* core & shared */
    CoreModule,
    SharedModule,

    /* Feature Modules */
    HomeModule,
    DiagnosticsModule,
    CreateAccountModule,

    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
      connectInZone: true,
    }),

    EffectsModule.forRoot([
      AuthEffects,
      ParcelEffects,
      MapControlEffects,
      AdminEffects,
      SiteEffects,
      NotificationEffects,
      AppConfigEffects,
    ]),
  ],
  providers: [
    /* Add singleton services */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorNotifierInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (cfg: AppConfigService) => () => cfg.load(),
      deps: [AppConfigService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (cfg: SiteStatusService) => () => cfg.load(),
      deps: [SiteStatusService],
      multi: true
    },
    CanDeactivateEditMapGuard,
    MapService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
